import { Pipe, PipeTransform } from '@angular/core'
import { Time } from 'media/time'

@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {
  transform (time: number|null|undefined, fps?: number, format?: string|boolean, adjustOffset?: boolean): string {
    if (format === undefined) {
      format = 'full'
    } else if (format === false) {
      format = 'full-seconds'
    }

    if (time === null || time === undefined || isNaN(time)) {
      return '--:--:--'
    }

    let timeObj = new Time(time)
    if (adjustOffset) {
      timeObj = timeObj.adjustOffset(fps)
    }

    return timeObj.toString(fps, format)
  }
}
